/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Спецификация АПИ управления сущностью SafeCityOsd
 */

/**
 * Сервис управления настройками OSD
 */
export class SafeCityOsdServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования настроек OSD
   */
  EditSafeCityOsd = (req: Pick<EditSafeCityOsdRequestDto, "updateMask"> & { data: SafeCityOsdRequestDto & fm.RequireAtLeastOne<SafeCityOsdRequestDto> }, init?: RequestInit): Promise<EditSafeCityOsdResponseDto> => {
    return fm.request<Pick<EditSafeCityOsdRequestDto, "updateMask"> & { data: SafeCityOsdRequestDto & fm.RequireAtLeastOne<SafeCityOsdRequestDto> }, EditSafeCityOsdResponseDto>(`${this.host}/device/api/v1/safe_city/osd`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек OSD
   */
  GetSafeCityOsd = (req?: GetSafeCityOsdRequestDto, init?: RequestInit): Promise<GetSafeCityOsdResponseDto> => {
    return fm.request<GetSafeCityOsdRequestDto, GetSafeCityOsdResponseDto>(`${this.host}/device/api/v1/safe_city/osd${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип размещения текста
 */
export enum SafeCityOsdPlacementType {
  /**
   * Значение не указано
   */
  PLACEMENT_TYPE_UNKNOWN = "PLACEMENT_TYPE_UNKNOWN",
  /**
   * Сверху слева
   */
  TOP_LEFT = "TOP_LEFT",
  /**
   * Сверху справа
   */
  TOP_RIGHT = "TOP_RIGHT",
  /**
   * Снизу слева
   */
  BOTTOM_LEFT = "BOTTOM_LEFT",
  /**
   * Снизу справа
   */
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
}
/**
 * Тип размещения текста
 */
export type SafeCityOsdPlacementTypeResponseEnum = keyof typeof SafeCityOsdPlacementType
/**
 * Тип размещения текста
 */
export type SafeCityOsdPlacementTypeRequestEnum = Exclude<SafeCityOsdPlacementTypeResponseEnum, "PLACEMENT_TYPE_UNKNOWN">;

/**
 * Тип добавления формата даты
 */
export enum SafeCityOsdShowDatetimeType {
  /**
   * Значение не указано
   */
  SHOW_DATETIME_TYPE_UNKNOWN = "SHOW_DATETIME_TYPE_UNKNOWN",
  /**
   * Формат отсутствует
   */
  ABSENT = "ABSENT",
  /**
   * День и время yyyy-mm-dd HH:MM:SS
   */
  DAY_TIME = "DAY_TIME",
  /**
   * Время HH:MM:SS
   */
  TIME = "TIME",
}
/**
 * Тип добавления формата даты
 */
export type SafeCityOsdShowDatetimeTypeResponseEnum = keyof typeof SafeCityOsdShowDatetimeType
/**
 * Тип добавления формата даты
 */
export type SafeCityOsdShowDatetimeTypeRequestEnum = Exclude<SafeCityOsdShowDatetimeTypeResponseEnum, "SHOW_DATETIME_TYPE_UNKNOWN">;

/**
 * Запрос редактирования настроек OSD
 */
export type EditSafeCityOsdRequestDto = {
  /**
   * Настройки OSD
   */
  data: SafeCityOsdRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования настроек OSD
 */
export type EditSafeCityOsdResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки OSD
   */
  readonly data: SafeCityOsdResponseDto
  /**
   * Ошибка
   */
  readonly error: EditSafeCityOsdResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditSafeCityOsdResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditSafeCityOsdResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения настроек OSD
 */
export type GetSafeCityOsdRequestDto = {
}
/**
 * Ответ на запрос получения настроек OSD
 */
export type GetSafeCityOsdResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки OSD
   */
  readonly data: SafeCityOsdResponseDto
}>
/**
 * Настройки OSD
 */
export type SafeCityOsdRequestDto = {
  /**
   * Флаг включения OSD
   */
  isOsdEnabled?: boolean
  /**
   * Текст
   */
  textline?: string
  /**
   * Размер текста, пикселей
   */
  textsize?: number
  /**
   * Размещение текста
   */
  placementType?: SafeCityOsdPlacementTypeRequestEnum | "PLACEMENT_TYPE_UNKNOWN"
  /**
   * Вариант добавления даты
   */
  showDatetimeType?: SafeCityOsdShowDatetimeTypeRequestEnum | "SHOW_DATETIME_TYPE_UNKNOWN"
  /**
   * Флаг отображения количества кадров в секунду
   */
  isShowFps?: boolean
  /**
   * Флаг отображения битрейта
   */
  isShowBitrate?: boolean
  /**
   * Флаг отображения количества потоков
   */
  isShowCountOfStreams?: boolean
  /**
   * Флаг отображения имени устройства
   */
  isShowNameOfDevice?: boolean
}
/**
 * Настройки OSD
 */
export type SafeCityOsdResponseDto = {
  /**
   * Флаг включения OSD
   */
  isOsdEnabled: boolean
  /**
   * Текст
   */
  textline: string
  /**
   * Размер текста, пикселей
   */
  textsize: number
  /**
   * Размещение текста
   */
  placementType: SafeCityOsdPlacementTypeResponseEnum
  /**
   * Вариант добавления даты
   */
  showDatetimeType: SafeCityOsdShowDatetimeTypeResponseEnum
  /**
   * Флаг отображения количества кадров в секунду
   */
  isShowFps: boolean
  /**
   * Флаг отображения битрейта
   */
  isShowBitrate: boolean
  /**
   * Флаг отображения количества потоков
   */
  isShowCountOfStreams: boolean
  /**
   * Флаг отображения имени устройства
   */
  isShowNameOfDevice: boolean
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос редактирования настроек OSD
   */
  "EditSafeCityOsdRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек OSD",
    "fields": {
      /**
       * Настройки OSD
       */
      "data": {
        "type": "SafeCityOsd",
        "text": "Настройки OSD",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования настроек OSD
   */
  "EditSafeCityOsdResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования настроек OSD",
    "fields": {
      /**
       * Настройки OSD
       */
      "data": {
        "type": "SafeCityOsd",
        "text": "Настройки OSD",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "EditSafeCityOsdResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditSafeCityOsdResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения настроек OSD
   */
  "GetSafeCityOsdRequest": {
    "kind": "class",
    "text": "Запрос получения настроек OSD",
  },
  /**
   * Ответ на запрос получения настроек OSD
   */
  "GetSafeCityOsdResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек OSD",
    "fields": {
      /**
       * Настройки OSD
       */
      "data": {
        "type": "SafeCityOsd",
        "text": "Настройки OSD",
      },
    },
  },
  /**
   * Настройки OSD
   */
  "SafeCityOsd": {
    "kind": "class",
    "text": "Настройки OSD",
    "fields": {
      /**
       * Флаг включения OSD
       */
      "isOsdEnabled": {
        "type": "bool",
        "text": "Флаг включения OSD",
      },
      /**
       * Текст
       */
      "textline": {
        "type": "string",
        "text": "Текст",
      },
      /**
       * Размер текста, пикселей
       */
      "textsize": {
        "type": "int32",
        "text": "Размер текста, пикселей",
      },
      /**
       * Размещение текста
       */
      "placementType": {
        "type": "SafeCityOsd.PlacementType",
        "text": "Размещение текста",
      },
      /**
       * Вариант добавления даты
       */
      "showDatetimeType": {
        "type": "SafeCityOsd.ShowDatetimeType",
        "text": "Вариант добавления даты",
      },
      /**
       * Флаг отображения количества кадров в секунду
       */
      "isShowFps": {
        "type": "bool",
        "text": "Флаг отображения количества кадров в секунду",
      },
      /**
       * Флаг отображения битрейта
       */
      "isShowBitrate": {
        "type": "bool",
        "text": "Флаг отображения битрейта",
      },
      /**
       * Флаг отображения количества потоков
       */
      "isShowCountOfStreams": {
        "type": "bool",
        "text": "Флаг отображения количества потоков",
      },
      /**
       * Флаг отображения имени устройства
       */
      "isShowNameOfDevice": {
        "type": "bool",
        "text": "Флаг отображения имени устройства",
      },
    },
  },
  /**
   * Тип размещения текста
   */
  "SafeCityOsd.PlacementType": {
    "kind": "enum",
    "text": "Тип размещения текста",
    "values": {
      /**
       * Значение не указано
       */
      "PLACEMENT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Сверху слева
       */
      "TOP_LEFT": {
        "i": 1,
        "text": "Сверху слева",
      },
      /**
       * Сверху справа
       */
      "TOP_RIGHT": {
        "i": 2,
        "text": "Сверху справа",
      },
      /**
       * Снизу слева
       */
      "BOTTOM_LEFT": {
        "i": 3,
        "text": "Снизу слева",
      },
      /**
       * Снизу справа
       */
      "BOTTOM_RIGHT": {
        "i": 4,
        "text": "Снизу справа",
      },
    },
  },
  /**
   * Тип добавления формата даты
   */
  "SafeCityOsd.ShowDatetimeType": {
    "kind": "enum",
    "text": "Тип добавления формата даты",
    "values": {
      /**
       * Значение не указано
       */
      "SHOW_DATETIME_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Формат отсутствует
       */
      "ABSENT": {
        "i": 1,
        "text": "Формат отсутствует",
      },
      /**
       * День и время yyyy-mm-dd HH:MM:SS
       */
      "DAY_TIME": {
        "i": 2,
        "text": "День и время yyyy-mm-dd HH:MM:SS",
      },
      /**
       * Время HH:MM:SS
       */
      "TIME": {
        "i": 3,
        "text": "Время HH:MM:SS",
      },
    },
  },
}